<template>
  <div class="timeline-container">
    <vue-timeline-update
        :date="new Date()"
        title="MoneySuperMarket"
        :thumbnail="require(`@/assets/msm.png`)"
        category="Test Lead"
        icon="code"
        color="purple"
    >
      <div id="tech-container">
        <div id="container-title">Tech</div>
        <div id="tech-wrapper" v-for="tech in msm.tech" :key="tech.value">
          <tech-blurb v-bind:value="tech"/>
        </div>
      </div>
      <br>
      <div id="responsibilties-container">
        <div id="container-title">Responsibilties</div>
        <div id="tech-wrapper" v-for="responsibility in msm.responsibilities" :key="responsibility.value">
          <tech-blurb v-bind:value="responsibility"/>
        </div>
      </div>
      <br>
      <div id="work-container">
        <vs-collapse open-hover>
          <vs-collapse-item not-arrow>
            <div slot="header">
              <div id="container-title">Experience</div>
              <p>Worked extensively in the Energy space. Responsibilities included absorbing the current test lead’s duties, understanding and refining SDLC processes, adopting Kanban, building out the energy squad in Manchester, implementing automation solutions and supporting the dev team to build in automation layers earlier in the lifecycle.</p>
            </div>
            <br>
            <p>Regularly pairing, mobbing and coding with the squads, providing workable solutions for the development team to pursue, reviewing PRs and providing feedback, ensuring appropriate monitoring mechanisms are in place (output to Grafana or using Cloudwatch) including logging and alerting. Identifying upcoming changes which would require additional streams of testing (security testing / performance testing), running the appropriate level of performance testing (tools such as gatling).</p>
            <br>
            <p>Working closely with the tech lead and architecture to discuss appropriate architectural solutions, layers of testing (automation layers, minimal manual layers, performance testing, contract testing, accessibility), implementing solutions (TestContainers, Pact, Nightwatch (before moving to Cypress), Rest Assured) and knowledge sharing with teams across MSM.</p>
            <br>
            <p>Responsible for delivering several micro services across multiple energy teams including services generating over £100m of revenue for the company. Heavily involved in decom activities from an aging tech stack (.NET stack / MSSQL Server / legacy data centres) to more modern micro services and cloud-based architecture (AWS / kubernetes).</p>
            <br>
            <p>Stepping in for the tech lead and supporting new tech leads on boarding process including knowledge sharing of dev / test processes, domain knowledge, project overview, streams of work, tech overview and important patterns adopted by the team to ensure smooth delivery.</p>
          </vs-collapse-item>
        </vs-collapse>
      </div>

    </vue-timeline-update>

    <!-- Latest update -->
    <vue-timeline-update
        :date="new Date('2016-08-01')"
        title="Ten10 : The University of Manchester"
        :thumbnail="require(`@/assets/uom.png`)"
        category="Senior Consultant"
        icon="code"
        color="purple"
    >
      <div id="tech-container">
        <div id="container-title">Tech</div>
        <div id="tech-wrapper" v-for="tech in ten10.tech" :key="tech.value">
          <tech-blurb v-bind:value="tech"/>
        </div>
      </div>
      <br>
      <div id="responsibilties-container">
        <div id="container-title">Responsibilties</div>
        <div id="tech-wrapper" v-for="responsibility in ten10.responsibilities" :key="responsibility.value">
          <tech-blurb v-bind:value="responsibility"/>
        </div>
      </div>
      <br>
      <div id="work-container">
        <vs-collapse open-hover>
          <vs-collapse-item not-arrow>
            <div slot="header">
              <div id="container-title">Experience</div>
              TBD
            </div>
          </vs-collapse-item>
        </vs-collapse>
      </div>
    </vue-timeline-update>

    <!-- Another update -->
    <vue-timeline-update
        :date="new Date('2015-08-01')"
        title="Amec Foster Wheeler"
        :thumbnail="require(`@/assets/amec.png`)"
        category="Test Lead"
        icon="code"
        color="turquoise"
    >
      <div id="tech-container">
        <div id="container-title">Tech</div>
        <div id="tech-wrapper" v-for="tech in amec.tech" :key="tech.value">
          <tech-blurb v-bind:value="tech"/>
        </div>
      </div>
      <br>
      <div id="responsibilties-container">
        <div id="container-title">Responsibilties</div>
        <div id="tech-wrapper" v-for="responsibility in amec.responsibilities" :key="responsibility.value">
          <tech-blurb v-bind:value="responsibility"/>
        </div>
      </div>
      <br>
      <div id="work-container">
        <vs-collapse open-hover>
          <vs-collapse-item not-arrow>
            <div slot="header">
              <div id="container-title">Experience</div>
              TBD
            </div>
          </vs-collapse-item>
        </vs-collapse>
      </div>
    </vue-timeline-update>

    <!-- Yet another update -->
    <vue-timeline-update
        :date="new Date('2012-08-01')"
        title="FDM : Target Group"
        :thumbnail="require(`@/assets/fdm.png`)"
        category="Test Consultant"
        icon="code"
        color="blue"
        is-last
    >
      <div id="tech-container">
        <div id="container-title">Tech</div>
        <div id="tech-wrapper" v-for="tech in fdm.tech" :key="tech.value">
          <tech-blurb v-bind:value="tech"/>
        </div>
      </div>
      <br>
      <div id="responsibilties-container">
        <div id="container-title">Responsibilties</div>
        <div id="tech-wrapper" v-for="responsibility in fdm.responsibilities" :key="responsibility.value">
          <tech-blurb v-bind:value="responsibility"/>
        </div>
      </div>
      <br>
      <div id="work-container">
        <vs-collapse open-hover>
          <vs-collapse-item not-arrow>
            <div slot="header">
              <div id="container-title">Experience</div>
              TBD
            </div>
          </vs-collapse-item>
        </vs-collapse>
      </div>
    </vue-timeline-update>
  </div>
</template>

<script>
import TechBlurb from './TechBlurb.vue'

export default {
  components: { TechBlurb },
  data: function () {
    return {
      msm: {
        tech: ['Java / SpringBoot', 'Postgres', 'AWS', 'Jenkins', 'ArgoCD', 'Cypress', 'VueJS', 'Nightwatch', 'TestContainers', 'Pact Contract Testing', 'Terraform', 'Gatling'],
        responsibilities: ['Test Lead', 'Line Management', 'Mentorship', 'Automation', 'All Types of Testing']
      },
      ten10: {
        tech: ['Ranorex', 'Selenium', 'Shell', 'Bitbucket', 'Confluence', 'Webdriver.io'],
        responsibilities: ['Automation', 'Test Planning', 'Test Strategy', 'Test Execution', 'Mentorship']
      },
      amec: {
        tech: ['SpiraTeam', 'MS Dynamics AX2009', 'MS Dynamics AX2012', 'DBFit / Fitnesse'],
        responsibilities: ['Test Lead', 'Automation', 'Scripting', 'Debugging']
      },
      fdm: {
        tech: ['MS SQL Server', 'Shell', 'Load Runner', 'HP Quality Center', 'Test Complete', 'Performance Center'],
        responsibilities: ['Test Planning', 'Execution', 'Scripting', 'Debugging', 'Test Management', 'Reporting']
      }
    }
  }
}
</script>

<style scoped lang="scss">
[class^="gb-"]:not(.gb-base-icon) {
  font-family: inherit !important;
}

.vs-collapse-item--icon-header  {
  position: inherit !important;
}
.gb-base-badge {
    font-family: inherit !important;
}

.timeline-container {
  font-weight: 300;
  margin: auto;
  max-width: 1200px;
  padding: 100px 0 100px 0;
}

#responsibilties-container {
  background-color: #F9CB40;
  color: black;
  padding: 1.2em 1.4em;
}

#tech-container {
  background-color: #494949;
  color: white;
  padding: 1.2em 1.4em;
}

#work-container {
  background-color: #348AA7;
  color:white;

  p {
    font-size: 15px;
  }
}

#container-title {
  font-size: 1.5em;
  padding-bottom: 10px;
}

#tech-wrapper {
  display: inline;
}

@media (max-width: 768px) {
  .timeline-container {
    padding: 40px 15px 40px 10px;
  }
}
</style>
